import { getQuotesList } from "services";
import { IStores } from "./index";
import { ListStoreConstructor } from "./ListStoreConstructor";

export class QuoteList extends ListStoreConstructor<any> {
  bidId: string = "";
  quoteSelectedId: string = "";

  setBidId(id: string) {
    this.bidId = id;
  }
  setQuoteSelectedId(id: string) {
    this.quoteSelectedId = id;
  }

  constructor(stores: IStores) {
    super(
      stores,
      (params) => {
        const paramsWithSort = {
          ...params,
          sort: stores.user.roles.isProvider ? ["created,desc"] : undefined,
        };
        return getQuotesList({ requestId: this.bidId }, paramsWithSort).then((response) => ({
          content: response.content || [],
          size: response.size || 0,
          totalPages: response.totalPages || 0,
          totalElements: response.totalElements || 0,
        }));
      },
      {
        pollingInterval: 10000,
      }
    );
  }

  get quoteSelectedData() {
    return this.allData.find((quote) => quote.id === this.quoteSelectedId);
  }
}
